"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Vultr;
    }
});
const _clients3 = require("@aws-sdk/client-s3");
const _GenericS3 = /*#__PURE__*/ _interop_require_default(require("~/plugins/GenericS3/GenericS3"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Vultr = class Vultr extends _GenericS3.default {
    get defaultParams() {
        var _this_input;
        return {
            Bucket: this.input.bucket,
            ACL: ((_this_input = this.input) == null ? void 0 : _this_input.acl) || 'public-read'
        };
    }
    async init() {
        const s3Options = {
            region: this.input.region,
            credentials: {
                accessKeyId: this.input.access_key,
                secretAccessKey: this.input.access_secret
            },
            endpoint: this.input.hostname
        };
        this.s3Client = new _clients3.S3(s3Options);
    }
    getUploadedPath(path) {
        const updatedEndpoint = this.input.hostname.startsWith('https://') ? this.input.hostname : `https://${this.input.hostname}`;
        return {
            url: `${updatedEndpoint}/${this.input.bucket}/${path}`
        };
    }
    constructor(input){
        super(input), this.name = 'Vultr';
    }
};
